import { useNavigate } from 'react-router-dom';
import { DeliveryProofNewPage } from '@/features/delivery-proof/components/DeliveryProofNewPage';

export const DeliveryProofNew = () => {
  const navigate = useNavigate();
  return (
    <DeliveryProofNewPage
      onComplete={() => navigate('/delivery-proofs')}
      onSaveDraft={() => navigate('/delivery-proofs?tab=drafts')}
    />
  );
};
